import React, { useRef, useState } from "react";
import { useDispatch, useSelector } from "react-redux";

import Pagination from "../../../../components/Pagination";
import { createCPDInitialValues, findDurationType, findTypeOfCpd } from "../../../../data/cpdConstants";
import moment from "moment";
import { CgClose } from "react-icons/cg";
import CreateCPDActivitiesForm from "../CreateCPDActivitiesForm";
import { getCPDById } from "../../../../redux/slices/atpSlice";
import { formatDateForDisplay } from "../../../../utils/helperFunctions";

function Approved({ data, handlePagination, pageLimit, currentPage }) {
    const [showModal, setShowModal] = useState(false);
    const [initialValues, setInitialValues] = useState(createCPDInitialValues);
    const [isView, setIsView] = useState(false);
    const [techFieldAdd, setTechFieldShow] = useState(false);
    const dispatch = useDispatch();
    const modalRef = useRef();
    const openModal = (detail = null) => {
        fetchByIdModal(detail?.id);
        setShowModal(true);
        setTechFieldShow(true);
        document.body.style.overflow = "hidden";
    };

    const fetchByIdModal = (id) => {
        dispatch(getCPDById(id)).then((response) => {
            setInitialValues({
                ...response?.payload,
                date_time: response?.payload?.date_time ? moment(response?.payload?.date_time).format("DD/MM/YYYY HH:mm A") : null,
                files: response?.payload?.attachment?.length > 0 ? response?.payload?.attachment[0] : [],
            });
        });
        setIsView(true);
    };
    const { current_page, total_pages } = useSelector((state) => state.atp.data);
    return (
        <>
            {showModal && (
                <div className="Add_form manuallyform_popup">
                    <div className={`modal custom-popup-overlay ${showModal ? "show" : ""}`}>
                        <div className="modal-content custom-popup-add" ref={modalRef}>
                            <div className="d-flex justify-content-between align-items-center">
                                {" "}
                                <h2>Add CPD Activity</h2>
                                <div
                                    onClick={(e) => {
                                        e.stopPropagation(); // Prevent event propagation to parent
                                        setIsView(false);
                                        document.body.style.overflow = "auto";
                                        setShowModal(false);
                                    }}
                                    className="d-flex justify-content-end croseicn"
                                >
                                    <CgClose
                                        style={{
                                            color: "#D1D5DB",
                                            height: "30px",
                                            width: "30px",
                                        }}
                                    />
                                </div>
                            </div>
                            <div className="after-line-tittle"></div>
                            <div>
                                <CreateCPDActivitiesForm initialValues={initialValues} isView={isView} techFieldAdd={techFieldAdd} />
                            </div>
                        </div>
                    </div>
                </div>
            )}
            <div>
                <div className="tabdiv accordion-body-cpd">
                    <table className="table_layout">
                        <thead>
                            <tr className="">
                                <th className="">No.</th>
                                <th className="">Title</th>
                                <th className="">Duration</th>
                                <th className="">Category </th>
                                <th className="">Approval Date</th>
                                <th className="">MBOT ATP No.</th>
                                <th className="">CPD Hours Granted</th>
                                <th className="">Action</th>
                            </tr>
                        </thead>
                        <div className="bordertop"></div>

                        {data?.length > 0 ? (
                            <tbody className="">
                                {data?.map((ele, index) => {
                                    return (
                                        <tr className="list-view-line-before" key={ele?.id}>
                                            <td className="text-decoration-none text-black">{(currentPage - 1) * pageLimit + index + 1}</td>
                                            <td style={{ textWrap: "balance", textDecoration: "underline" }} className="cursor-pointer text-primary-sapphire" onClick={() => {
                                                setIsView(true); // Set isView to true
                                                openModal(ele); // Call openModal with view as true
                                            }}>
                                                {ele?.title}
                                            </td>
                                            <td>
                                                {ele?.duration_time} {findDurationType(ele?.duration_type)}
                                            </td>
                                            <td>{findTypeOfCpd(ele?.type_of_cpd)}</td>
                                            <td>{formatDateForDisplay(ele?.approval_date)}</td>
                                            <td>{ele?.approval_id}</td>
                                            <td className="text-center">{ele?.awarded_cpd}</td>
                                            <td>
                                                <div className="view_itm d-flex flex-column" style={{ cursor: "pointer", textWrap: "balance" }}>
                                                    <a
                                                        href={ele?.certificate?.[0]?.atp_certificate_path} // Corrected the href to use the certificate path
                                                        target="_blank"
                                                        rel="noopener noreferrer"
                                                        className="text-primary-sapphire fw-400 fs-16"
                                                        style={{ fontFamily: "Poppins-Regular" }}
                                                    >
                                                        Download PDF file by approval date
                                                    </a>
                                                </div>
                                            </td>
                                        </tr>
                                    );
                                })}
                            </tbody>
                        ) : (
                            <tbody>
                                <tr>
                                    <td colSpan={6} className="text-decoration-none text-center">
                                        No Data Available
                                    </td>
                                </tr>
                            </tbody>
                        )}
                    </table>
                </div>
                <Pagination currentPage={current_page} totalPages={total_pages} setCurrentPage={handlePagination} />
            </div>
        </>
    );
}

export default Approved;
